export const getDirectionAwarePlacement = ({ placement, isLtr, }) => {
    const map = {
        'top-start': isLtr ? 'top-start' : 'top-end',
        'top': 'top',
        'top-end': isLtr ? 'top-end' : 'top-start',
        'end-top': isLtr ? 'right-start' : 'left-start',
        'end': isLtr ? 'right' : 'left',
        'end-bottom': isLtr ? 'right-end' : 'left-end',
        'bottom-end': isLtr ? 'bottom-end' : 'bottom-start',
        'bottom': 'bottom',
        'bottom-start': isLtr ? 'bottom-start' : 'bottom-end',
        'start-bottom': isLtr ? 'left-end' : 'right-end',
        'start': isLtr ? 'left' : 'right',
        'start-top': isLtr ? 'left-start' : 'right-start',
    };
    return map[placement];
};
//# sourceMappingURL=get_direction_aware_placement.js.map